module.exports = __webpack_public_path__ + "static/media/logojamirabranco.32c5916b.png";